/**
  * 商城 接口的统一出口
  */
 import axios from '../http' // 导入http中创建的axios实例
 import qs from 'qs' // 根据需求是否导入qs模块，把请求字段直接映射过来
 
//  const api = '/home/'
 
 const index = {
    // 园区商品列表
    goods (params) {
        return axios.post('/home/park/goods', qs.stringify(params))
	},
	// 园区banner
	banner (params) {
        return axios.get('/home/park/banner', {params,params})
	},
	// 园区列表
	list(params){
		return axios.get('/home/park/index', {params,params})
	}
    
 }
 
 // 导出接口
 export default index